/**
 * Feature Flags Configuration
 *
 * Toggle features on/off for production releases.
 * Set to `true` to enable, `false` to disable.
 */

const featureFlags = {
  // 🚧 Shopping Cart & Checkout System
  enableShoppingCart: false,

  // 🚧 Gallery Page & Public Scene Sharing
  enableGallery: false,
};

export default featureFlags;
